import { Typography } from '@material-ui/core'
import clsx from 'clsx'
import { useTreeViewStyles } from 'components/WorkspaceEditor/styles'
import React, { memo } from 'react'

/**
 * Renders the order label for Article or Paragraph nodes.
 * @param {string} itemOrder - Order of node from Tree
 * @param {any} classes - CSS classes to apply to the component
 */
export interface NodeOrderProps {
    itemOrder: string
    classes?: string
}

export const NodeOrder = memo<NodeOrderProps>(({ itemOrder, classes }) => {
    const classNames = useTreeViewStyles()

    return (
        <Typography
            variant="caption"
            data-testid="node-order"
            className={clsx(classNames.itemOrderTypography, classes)}
        >
            {itemOrder}
        </Typography>
    )
})
